import { Helmet } from 'react-helmet'
import './productPage.style.scss'
import React, { lazy, Suspense } from 'react';
import { ButtonComponent, ContainerComponent, ImageSwiper, ParagraphComponent, ProductCardComponent, ProductCardSkeletonComponent, SubtitleComponent, TitleComponent, WideProuctCard } from '../../components'
import { useCartStore, useProductStore } from '../../store';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Product } from '../../components/productCard/data';
import { CategoryEquipment, convertChargerCategoryLink } from '../equipment/categories';
import { NavLink } from 'react-router-dom';

import downloadIcon from '../../assets/icons/download.svg';
import arrowLeft from '../../assets/icons/arrowLeftWhite.svg';
import cartIcon from '../../assets/icons/cart.svg';
import imagePlaceholder from '../../assets/images/imagePlaceholder.svg';

import ProductPageSkeletonComponent from './productPageSkeleton.component';
import plusIcon from '../../assets/icons/plus.svg';
import minusIcon from '../../assets/icons/minus.svg';

import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Pagination, Navigation } from 'swiper';
// import RecommendedProducts from './RecomendedProducts';

const RecommendedProducts = lazy(() => import('./RecomendedProducts'));

function ProductPage() {
    const { t, i18n } = useTranslation();
    // const { state } = useLocation();
    const { id: ref } = useParams();

    const navigate = useNavigate();
    // const { category } = state;
    const { error, fetchProduct, product, resetProduct, solarPanels, fetchSolarPanels, batteries, fetchBatteries, inverters, fetchInverters, cables, fetchCables, chargers, fetchChargers, fetchChargerAccessories, charger_accessories, loading } = useProductStore();
    const { addToCart, toggleCart, setToogleCart } = useCartStore();

    const [productQuantity, setProductQuantity] = useState(1)
    const [tempProduct, setTempProduct] = useState<Product>();
    const [tempRecProducts, setTempRecProducts] = useState<Product[]>([]);
    const sleep = (ms: number) => new Promise(r => setTimeout(r, ms));

    let categoriesEquipment: CategoryEquipment = t('solarEquipment.categories')

    let categoriesForRecFetch = {
        'solar_panels': fetchSolarPanels,
        'batteries': fetchBatteries,
        'inverters': fetchInverters,
        'cables_and_connectors': fetchCables,
        'battery_accessories': fetchBatteries,
        'inverter_accessories': fetchInverters,
        'chargers': fetchChargers,
        'charger_accessories': fetchChargerAccessories
    }

    let categoriesForRec = {
        'solar_panels': solarPanels,
        'batteries': batteries,
        'inverters': inverters,
        'cables_and_connectors': cables,
        'battery_accessories': batteries,
        'inverter_accessories': inverters,
        'chargers': chargers,
        'charger_accessories': charger_accessories
    }

    function addProductToCart(quantity: number) {
        if (product) { addToCart(product, quantity) }
    }


    function renderCategory(currentCategory: string) {
        if (currentCategory as keyof CategoryEquipment) {
            return (categoriesEquipment[currentCategory as keyof CategoryEquipment]);
        }
        else return ('');
    }

    const toggleCartExpansion = async () => {
        await sleep(200);
        setToogleCart(toggleCart);
    };

    useEffect(() => {

        const fetchCurrentProduct = async () => {
            if (ref) fetchProduct(ref)

        }

        if (!tempProduct) { fetchCurrentProduct() }

        return () => {
            resetProduct()
        };

    }, [])

    useEffect(() => {

        const fetchCurrentProduct = async () => {
            if (ref && tempProduct) fetchProduct(ref)

        }

        fetchCurrentProduct()

        return () => {
            resetProduct()
        };
    }, [ref])


    type CategoryKey = keyof typeof categoriesForRec;

    useEffect(() => {
        if (product != null && product.categoryUrl != undefined) {
            setTempProduct(product)

        }

    }, [product])

    useEffect(() => {

        const fetchCurrentProductRecs = async () => {
            categoriesForRecFetch[tempProduct?.categoryUrl as CategoryKey](0)

        }

        if (tempProduct != undefined && categoriesForRec[tempProduct.categoryUrl as CategoryKey]?.products.length <= 0) { fetchCurrentProductRecs() }

    }, [tempProduct])


    useEffect(() => {
        if (productQuantity === 0) setProductQuantity(1)
    }, [productQuantity])


    useEffect(() => {
        if (error) navigate("/" + i18n.resolvedLanguage + t('navbar.routes.notFound'))
    }, [error])

    // useEffect(() => {
    //     console.log('ref triggered');

    //     const fetchCurrentProduct = async () => {
    //         if (ref) fetchProduct(ref);
    //     }

    //     if (tempProduct && !tempProduct.id) { fetchCurrentProduct() }

    //     return () => {
    //         resetProduct()
    //     };

    // }, [ref])



    return (
        <div className='productPage'>
            {tempProduct && !loading ?
                <>
                    <Helmet>
                        <title>{tempProduct.brand + " - " + tempProduct.title}</title>
                        <meta name="description" content={tempProduct.desc} />
                    </Helmet>
                    <ContainerComponent>
                        <NavLink className="backButton" to=".."><><img src={arrowLeft} />{t('misc.goBack')}</></NavLink>
                        <div className="productContainer">
                            <div className="imageDiv">
                                {/* <ImageSwiper images={[tempProduct.image === undefined ? imagePlaceholder : tempProduct.image]} thumbs={true} /> */}
                                <img src={tempProduct.image === '' ? imagePlaceholder : tempProduct.image} alt={`Product image of ${tempProduct.title}`} />
                            </div>
                            <div className="contentDiv">
                                <div className="productInfo">
                                    <h2><SubtitleComponent className='productBrand'>
                                        <NavLink to={"/" + i18n.resolvedLanguage + convertChargerCategoryLink(tempProduct.categoryUrl ? tempProduct.categoryUrl : '') + "/" + t(`solarEquipment.urlCategories.${tempProduct.categoryUrl}`)}>{tempProduct.categoryUrl ? renderCategory(tempProduct.categoryUrl) : tempProduct.category} </NavLink>
                                        {tempProduct.brand ? '-' : null} {tempProduct.brand}
                                    </SubtitleComponent></h2>
                                    <h1><TitleComponent className='productTitle'>{tempProduct.title}</TitleComponent></h1>
                                    {tempProduct.ref && <h3><ParagraphComponent className='productRef'>{t('productsCard.ref')} {tempProduct.ref}</ParagraphComponent></h3>
                                    }
                                    <ParagraphComponent className='productDescription'><span>{t('productsCard.brand')}</span> {tempProduct.brand}</ParagraphComponent>
                                    <ParagraphComponent className='productDescription'><span>{t('productsCard.description')}</span> {tempProduct.desc}</ParagraphComponent>
                                    <ParagraphComponent className='productSpecifications' dark><a href={tempProduct.url}>{t('productsCard.specifications')}<img className='downloadIcon' src={downloadIcon} /></a></ParagraphComponent>
                                    {/* <h3><SubtitleComponent className={`productPrice ${tempProduct.stock === 0 && 'outOfStockPrice'}`}>{tempProduct.price.toFixed(2).toString().replace(".", ",")} &euro;</SubtitleComponent></h3> */}
                                    <h4><ParagraphComponent className='productStock'>{tempProduct.stock ? (
                                        <>
                                            {t('productsCard.inStock')} {<span>{tempProduct.stock.toString()}</span>}
                                        </>
                                    ) : (
                                        t('productsCard.outOfStock')
                                    )}</ParagraphComponent></h4>
                                </div>
                                {tempProduct.stock ?
                                    <div className="buttonContainer">

                                        <ButtonComponent categoryId='addToCart' white onClick={() => { addProductToCart(productQuantity); toggleCartExpansion(); }}>{t('productsCard.addToCart')}<img className='cartIcon' src={cartIcon} />
                                        </ButtonComponent>
                                        <div className="productQuantity">
                                            <img onClick={() => {
                                                productQuantity >= 2 && setProductQuantity(productQuantity - 1)
                                            }} src={minusIcon} />
                                            <input type='number' max={tempProduct.stock} value={productQuantity} onChange={(event) => { setProductQuantity(Number(event.target.value)) }} min={1} />
                                            <img onClick={() => { tempProduct.stock && productQuantity < tempProduct.stock && setProductQuantity(productQuantity + 1) }} src={plusIcon} />
                                        </div>
                                    </div>
                                    : <ButtonComponent ghost style={{ marginTop: '1rem' }} onClick={() => { }}>{t('productsCard.outOfStock')}</ButtonComponent>}


                            </div>
                        </div>
                        <SubtitleComponent white semiBold>Similar products</SubtitleComponent>
                        <div className="recommendedProducts">
                            <Suspense fallback={<p>Loading...</p>}>
                                {tempProduct && (
                                    <RecommendedProducts products={categoriesForRec[tempProduct.categoryUrl as CategoryKey]?.products
                                         || []} />
                                )}
                            </Suspense>
                        </div>


                    </ContainerComponent>
                </>
                : tempProduct && loading ?
                    <>
                        <Helmet>
                            <title>{tempProduct.brand + " - " + tempProduct.title}</title>
                            <meta name="description" content={tempProduct.desc} />
                        </Helmet>
                        <ContainerComponent>
                            <NavLink className="backButton" to=".."><><img src={arrowLeft} />{t('misc.goBack')}</></NavLink>
                            <div className="productContainer">
                                <div className="imageDiv">
                                    {/* <ImageSwiper images={[tempProduct.image === undefined ? imagePlaceholder : tempProduct.image]} thumbs={true} /> */}
                                    <img src={tempProduct.image === '' ? imagePlaceholder : tempProduct.image} alt={`Product image of ${tempProduct.title}`} />
                                </div>
                                <div className="contentDiv">
                                    <div className="productInfo">
                                        <h2><SubtitleComponent className='productBrand'>
                                            <NavLink to={"/" + i18n.resolvedLanguage + convertChargerCategoryLink(tempProduct.categoryUrl ? tempProduct.categoryUrl : '') + "/" + t(`solarEquipment.urlCategories.${tempProduct.categoryUrl}`)}>{tempProduct.categoryUrl ? renderCategory(tempProduct.categoryUrl) : tempProduct.category} </NavLink>
                                            {tempProduct.brand ? '-' : null} {tempProduct.brand}
                                        </SubtitleComponent></h2>
                                        <h1><TitleComponent className='productTitle'>{tempProduct.title}</TitleComponent></h1>
                                        {tempProduct.ref && <h3><ParagraphComponent className='productRef'>{t('productsCard.ref')} {tempProduct.ref}</ParagraphComponent></h3>
                                        }
                                        <ParagraphComponent className='productDescription'><span>{t('productsCard.brand')}</span> {tempProduct.brand}</ParagraphComponent>
                                        <ParagraphComponent className='productDescription'><span>{t('productsCard.description')}</span> {tempProduct.desc}</ParagraphComponent>
                                        <ParagraphComponent className='productSpecifications' dark><a href={tempProduct.url}>{t('productsCard.specifications')}<img className='downloadIcon' src={downloadIcon} /></a></ParagraphComponent>
                                        {/* <h3><SubtitleComponent className={`productPrice ${tempProduct.stock === 0 && 'outOfStockPrice'}`}>{tempProduct.price.toFixed(2).toString().replace(".", ",")} &euro;</SubtitleComponent></h3> */}
                                        <h4><ParagraphComponent className='productStock'>{tempProduct.stock ? (
                                            <>
                                                {t('productsCard.inStock')} {<span>{tempProduct.stock.toString()}</span>}
                                            </>
                                        ) : (
                                            t('productsCard.outOfStock')
                                        )}</ParagraphComponent></h4>
                                    </div>
                                    {tempProduct.stock ?
                                        <div className="buttonContainer">

                                            <ButtonComponent categoryId='addToCart' white onClick={() => { addProductToCart(productQuantity); toggleCartExpansion(); }}>{t('productsCard.addToCart')}<img className='cartIcon' src={cartIcon} />
                                            </ButtonComponent>
                                            <div className="productQuantity">
                                                <img onClick={() => {
                                                    productQuantity >= 2 && setProductQuantity(productQuantity - 1)
                                                }} src={minusIcon} />
                                                <input type='number' max={tempProduct.stock} value={productQuantity} onChange={(event) => { setProductQuantity(Number(event.target.value)) }} min={1} />
                                                <img onClick={() => { tempProduct.stock && productQuantity < tempProduct.stock && setProductQuantity(productQuantity + 1) }} src={plusIcon} />
                                            </div>
                                        </div>
                                        : <ButtonComponent ghost style={{ marginTop: '1rem' }} onClick={() => { }}>{t('productsCard.outOfStock')}</ButtonComponent>}


                                </div>
                            </div>
                            {/* <SubtitleComponent white semiBold>Similar products</SubtitleComponent>
                            <div className="recommendedProducts">
                                <Suspense fallback={<p>Loading...</p>}>
                                    {tempProduct && (
                                        <RecommendedProducts products={categoriesForRec[tempProduct.categoryUrl as CategoryKey]?.products || []} />
                                    )}
                                </Suspense>
                            </div> */}


                        </ContainerComponent>
                    </>
                    : tempProduct === undefined && loading ?
                        <ContainerComponent>
                            <ProductPageSkeletonComponent></ProductPageSkeletonComponent>
                        </ContainerComponent>
                        : tempProduct === undefined && !loading || error &&
                        <div className='notFound'>
                            <Helmet>
                                <title>{t('productPage.notFound')}</title>
                            </Helmet>
                            <TitleComponent medium>{t('productPage.t1')}</TitleComponent>
                            <TitleComponent moreSmaller medium >{t('productPage.t2')}</TitleComponent>
                            <div className="linksDiv">
                                <ParagraphComponent>
                                    {t('navbar.cart.products')} <NavLink to={"/" + i18n.resolvedLanguage + t('navbar.routes.equipment')}>{t('navbar.cart.solarProducts')}</NavLink> {t('navbar.cart.or')} <NavLink to={"/" + i18n.resolvedLanguage + t('navbar.routes.chargers')}>{t('navbar.cart.EV')}</NavLink>
                                </ParagraphComponent>
                            </div>
                        </div>

            }
        </div>
    )
}



export default ProductPage